import type { FC } from "react";
import type { ReactFormExtendedApi } from "@tanstack/react-form";

import GeneralHealthForm from "@/components/form/patient/general-health-form";
import HygieneForm from "@/components/form/patient/hygiene-form";
import InformationsForm from "@/components/form/patient/informations-form";
import RiskFactorsForm from "@/components/form/patient/risk-factors-form";
import type { UpdatePatientFormData } from "@/schemas/patient";
import type { UpdateTab } from "@/types/utils";

type UpdateTabFormProps = {
  selectedTab: UpdateTab;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formApi: ReactFormExtendedApi<
    UpdatePatientFormData,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any
  >;
};

const UpdateTabForm: FC<UpdateTabFormProps> = ({ selectedTab, formApi }) => {
  switch (selectedTab) {
    case "INFOS":
      return <InformationsForm formApi={formApi} />;
    case "RISK_FACTORS":
      return <RiskFactorsForm formApi={formApi} />;
    case "GENERAL_HEALTH":
      return <GeneralHealthForm formApi={formApi} />;
    case "HYGIENE":
      return <HygieneForm formApi={formApi} />;
    default:
      return <InformationsForm formApi={formApi} />;
  }
};

export default UpdateTabForm;
